import React from "react";
import LokasiContext from "./context/context";
import LokasiWrapper from "./ui/LokasiWrapper";

const Lokasi = () => {
	return (
		<LokasiContext>
			<LokasiWrapper />
		</LokasiContext>
	);
};

export default Lokasi;
